// Auto-generated skeleton for Faq

export const Faq: Api.Faq = {
  id: 0,
  faq_category: null,
  faq_category_id: 0,
  documents: [],
  ordering: 0,
  question: '',
  answer: '',
  created: null,
  updated: null,
};

